import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { leftArrow, rightArrow } from '../../Helper/svgs';
import './RoundButton.css';

class RoundButton extends Component {
  render() {
    return (
      <motion.button onClick={this.props.onClick} className={`round-btn ${this.props.className}`} whileTap={{ scale: '0.9' }}>
        {this.props.content}
      </motion.button>
    );
  }
}

class CustomRoundButton extends RoundButton {
  // No need to define constructor as it's inherited from RoundButton
}

class LeftRoundButton extends RoundButton {
  render() {
    return (
      <motion.button onClick={this.props.onClick} className={`round-btn ${this.props.className}`} whileTap={{ scale: '0.9' }}>
        {leftArrow()}
      </motion.button>
    );
  }
}

class RightRoundButton extends RoundButton {
  render() {
    return (
      <motion.button onClick={this.props.onClick} className={`round-btn ${this.props.className}`} whileTap={{ scale: '0.9' }}>
        {rightArrow()}
      </motion.button>
    );
  }
}

export { LeftRoundButton, RightRoundButton, CustomRoundButton };